import { DEFAULTS } from "./defaults.js";
import { CODE_BLOCK_TYPE } from "./types.js";
const pluginCodeBlock = (config) => {
  return {
    config: { ...DEFAULTS.config, ...config },
    type: CODE_BLOCK_TYPE
  };
};
export {
  pluginCodeBlock
};
//# sourceMappingURL=viewer.js.map
